import {
  call, put, select,
  takeLeading,
  delay,
} from 'redux-saga/effects';

import {
  callApi,
  Endpoint,
} from 'api';
import { sagaExceptionHandler } from 'utils';
import type { AvatarType } from 'types';

import { authSelectors } from 'store/auth/selectors';

import { ProfileActionType } from './actionsTypes';
import {
  profileSetState,
  type savePassword,
  type saveProfileInfo,
} from './actionCreators';
import type { ProfileData, ProfileDataRequest } from './types';

export function* getProfileSaga() {
  try {
    const {
      user: {
        last_name: lastName,
        first_name: firstName,
        third_name: fatherName,
        referral_code: referralCode,
        email,
        phone,
        telegram,
        balance,
        id,
        rank,
        country,
        is_company: isCompany,
        is_verified: isVerified,
        company_name: companyName,
        is_qualified: isQualified,
        tin,
        qualification_purchase_date: dataActive,
        qualification_expiration: dataDeActive,
        eki_quantity: ekiQuantity,
        raffle_tickets: raffleTickets,
        status,
      },
    }:ProfileDataRequest = yield call(callApi, {
      endpoint: Endpoint.Profile,
    });

    const { avatar }:AvatarType = yield call(callApi, {
      endpoint: Endpoint.ProfileEditAvatar,
    });

    const { challenge } = yield call(callApi, {
      endpoint: Endpoint.Challenge,
    });
    yield put(profileSetState({
      avatar,
      lastName,
      firstName,
      fatherName,
      email,
      phone,
      telegram,
      balance,
      referralCode,
      id,
      rank,
      countryProfile: country,
      isCompany,
      isVerified,
      companyName,
      tin,
      isQualified,
      dataActive,
      dataDeActive,
      ekiQuantity,
      raffleTickets,
      challenge,
      status,
    }));
  } catch (exception) {
    sagaExceptionHandler(exception);
  }
}

export function* saveAvatarSaga() {
  try {
    yield put(profileSetState({ isSavingAvatar: true }));
    // Костыль от которого надо будет избавиться
    yield delay(700);
    const { avatar }:AvatarType = yield call(callApi, {
      endpoint: Endpoint.ProfileEditAvatar,
    });
    yield put(profileSetState({
      avatar,
    }));
  } catch (exception) {
    sagaExceptionHandler(exception);
    yield put(profileSetState({ isSavingAvatar: false }));
  } finally {
    yield put(profileSetState({ isSavingAvatar: false }));
  }
}

export function* saveProfileInfoSaga({
  payload: { onCallback },
}: ReturnType<typeof saveProfileInfo>) {
  try {
    const {
      lastName,
      firstName,
      fatherName,
      companyName,
      tin,
      email,
      phone,
      telegram,
      countryProfile,
    }: ProfileData = yield select(authSelectors.getState);

    yield put(profileSetState({ isLoading: true }));

    yield call(callApi, {
      method: 'PUT',
      endpoint: Endpoint.ProfileEdit,
      payload: {
        last_name: lastName,
        first_name: firstName,
        third_name: fatherName,
        company_name: companyName,
        tin,
        email,
        phone,
        telegram,
        country: countryProfile,
      },
    });

    yield call(saveAvatarSaga);

    yield put(profileSetState({ isLoading: false }));

    if (onCallback) {
      yield onCallback();
    }
  } catch (exception) {
    sagaExceptionHandler(exception);
    yield put(profileSetState({ isLoading: false }));
  }
}

export function* savePasswordSaga({
  payload: {
    old_password,
    password,
    password_confirm,
    onCallback,
  },
}: ReturnType<typeof savePassword>) {
  try {
    yield put(profileSetState({ isLoading: true }));
    yield call(callApi, {
      method: 'POST',
      endpoint: Endpoint.ChangePassword,
      payload: {
        old_password,
        password,
        password_confirm,
      },
    });
    yield put(profileSetState({ isLoading: false }));
    if (onCallback) {
      yield onCallback();
    }
  } catch (exception) {
    sagaExceptionHandler(exception);
    yield put(profileSetState({ isLoading: false }));
  }
}

export function* claimCashbackSaga() {
  try {
    yield put(profileSetState({ isLoading: true }));
    yield call(callApi, {
      method: 'POST',
      endpoint: Endpoint.ClaimCashback,
    });
    yield call(getProfileSaga);
    yield put(profileSetState({ isLoading: false }));
  } catch (exception) {
    sagaExceptionHandler(exception);
  }
}

export const ProfileEffects = [
  takeLeading(ProfileActionType.GET_DATA, getProfileSaga),
  takeLeading(ProfileActionType.SAVE_PROFILE_INFO, saveProfileInfoSaga),
  takeLeading(ProfileActionType.SAVE_PASSWORD, savePasswordSaga),
  takeLeading(ProfileActionType.SAVE_AVATAR, saveAvatarSaga),
  takeLeading(ProfileActionType.CLAIM_CASHBACK, claimCashbackSaga),
];
